module.exports = __webpack_public_path__ + "img/cinnamon-baked-oatmeal.b7bb6765.jpg";